import BaseComponent from './BaseComponent';

class JobList extends BaseComponent {
    constructor(el) {
        super(el);
        this.el = el;
        this.handlePagination();
    }

    handlePagination() {
        document.body.addEventListener('click', (e) => {
            if (!e.target.closest('#job-load-more')) {
                return;
            }
            e.preventDefault();
            e.target.classList.add('is-active');
            fetch(e.target.dataset.href)
                .then(function (response) {
                    if (response.ok) {
                        return response.text();
                    }
                    return Promise.reject(response);
                })
                .then(function (html) {
                    const div = document.createElement('div');
                    div.innerHTML = html;
                    e.target.outerHTML = div.querySelector('.job-list-ajax').innerHTML;
                })
                .catch(function (error) {
                    console.warn(error);
                });
        });
    }
}

export default JobList;
